<template>
    <div component="NavigationMenu" :class="{ small }">
        <template v-for="(item, index) in menuItems" :key="index">
            <router-link
                class="item outline"
                v-if="item.route"
                :icon="item.icon"
                :to="{ name: item.route }"
                :disabled="item.disabled"
                @click="$emit('hide')"
            >
                {{ item.label }}
            </router-link>

            <div class="item"
                 v-if="item.emits"
                 :data-icon="item.icon"
                 @click="$emit(item.emits)"
            >
                {{ item.label }}
            </div>
        </template>
    </div>
</template>

<script>
import {defineComponent} from 'vue';
import {useAuthStore} from '@stores/';
import {useRouter} from 'vue-router';
import {useI18n} from 'vue-i18n';

export default defineComponent({
    name: 'NavigationMenu',

    setup() {
        const {t} = useI18n();
        const authStore = useAuthStore();
        const router = useRouter();

        return {t, authStore, router};
    },

    props: {
        small: {
            type: Boolean,
            default: false
        }
    },

    data: () => ({
        userSidebar: false,
        menuItems: [
            {
                label: 'Newsletter',
                icon: 'forward_to_inbox',
                route: 'Newsletters'
                // disabled: true
            },
            {
                label: 'Zákazníci',
                icon: 'group',
                route: 'Customers'
                // disabled: true
            },
            {
                label: 'Odhlásiť sa',
                icon: 'power_settings_new',
                route: null,
                emits: 'logout'
                // disabled: true
            }
        ]
    }),

    computed: {},

    methods: {}
});
</script>

<style lang="scss" scoped>
@use '@scss/mixins';
@use '@scss/variables';
@use "sass:color";

[component='NavigationMenu'] {
    overflow: hidden;
    display: flex;
    flex-direction: column;
    background-color: rgba(black, 30%);

    &.small {
        .item {
            padding-left: 12px;
            font-size: 0;
            gap: 0;
        }
    }

    .item {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        gap: 15px;
        color: rgba(variables.$white, 70%);
        font-size: 15px;
        font-weight: bold;
        padding: 10px;
        border-bottom: 1px solid rgba(variables.$white, 24%);
        cursor: pointer;
        transition: 0.3s;
        white-space: nowrap;
        height: 50px;

        &[disabled] {
            pointer-events: none;
            opacity: 0.5;
        }

        &:hover {
            background-color: color.mix(variables.$primary, variables.$black, 10%);
        }

        &.router-link-active,
        .router-link-exact-active {
            background-color: color.mix(variables.$primary, variables.$black, 20%);
            color: rgba(variables.$white, 80%);
        }
    }
}
</style>
